/**
 * Formateador de Identificación por País
 */

/** Fecha local YYYY-MM-DD (toISOString da la fecha UTC: de noche en Chile ya es "mañana"). */
export const formatLocalDate = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const todayLocal = () => formatLocalDate(new Date());

export const formatChileanRUT = (value: string) => {
    // Limpiar caracteres no permitidos
    let clean = value.replace(/[^0-9kK]/g, '').toUpperCase();
    if (clean.length > 10) clean = clean.slice(0, 10);

    if (clean.length < 2) return clean;

    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);

    // Formatear cuerpo con puntos
    let formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `${formattedBody}-${dv}`;
};

export const formatGenericID = (value: string, country: string) => {
    // Limpiar valor
    const clean = value.replace(/[\s\.\-]/g, '');

    switch (country) {
        case 'Chile':
            return formatChileanRUT(value);

        case 'Argentina':
        case 'Paraguay':
            // 88.888.888
            return value.replace(/\D/g, '')
                .slice(0, 8)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        case 'United States':
            // 000-00-0000
            const ssn = value.replace(/\D/g, '').slice(0, 9);
            if (ssn.length > 5) return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`;
            if (ssn.length > 3) return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
            return ssn;

        default:
            return value; // Sin formato específico por ahora
    }
};

export const calculateAge = (birthDate?: string | null | undefined, fallbackAge?: any) => {
    if (birthDate && birthDate.trim() !== '' && birthDate !== '0000-00-00') {
        try {
            const birth = new Date(birthDate);
            if (!isNaN(birth.getTime())) {
                const now = new Date();
                let years = now.getFullYear() - birth.getFullYear();
                let months = now.getMonth() - birth.getMonth();
                if (months < 0 || (months === 0 && now.getDate() < birth.getDate())) {
                    years--;
                    months += 12;
                }
                if (years > 0) return `${years} año${years !== 1 ? 's' : ''}`;
                if (months > 0) return `${months} mes${months !== 1 ? 'es' : ''}`;
                return 'Cachorro';
            }
        } catch { }
    }
    // Si fallbackAge existe, lo retornamos (aunque sea string como "1 año")
    return fallbackAge ? fallbackAge.toString() : 'Edad N/A';
};
